import { twMerge } from 'tailwind-merge';

import { GradientBorderProps } from './types';

export const GradientBorder = ({
  className,
  gradientClassName,
}: GradientBorderProps) => (
  <div
    className={twMerge(
      'pointer-events-none absolute inset-0 -z-[1]',
      className
    )}
  >
    <div
      style={{
        mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
      }}
      className={twMerge(
        'absolute inset-0 -z-[1] rounded-[inherit] !mask-exclude p-[1.5px]',
        gradientClassName
      )}
    />
  </div>
);
